import { ReactNode } from 'react';

import styles from './TournamentListPage.module.css';

export type Props = {
  navigation: ReactNode;
  allTournamentsList: ReactNode;
};
export function TournamentListPage({ navigation, allTournamentsList }: Props) {
  return (
    <>
      <div className={styles.promoNavigation}>{navigation}</div>

      <div className={styles.tournaments}>{allTournamentsList}</div>
    </>
  );
}
